import '../styles/accordion.scss'

class Collapsible extends Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: false,
        }
    }

    toggleCollapse() {
        const { expanded } = this.state
        this.setState({ expanded: !expanded })
    }

    render() {
        const { label, content } = this.props
        const { expanded } = this.state

        const activeClass = expanded ? 'show' : ''
        const html = { __html: content }

        return (
            <div className="card">
                <div className={`card-header ${activeClass}`} onClick={this.toggleCollapse.bind(this)} role="tab">
                    <h4 className="mb-0">
                        <a>{label}</a>
                    </h4>
                    <span className="indicator">
                        <i className="indicator-icon" />
                    </span>
                </div>

                <div className={`collapse ${activeClass}`} role="tabpanel">
                    <div className="card-block" dangerouslySetInnerHTML={html} />
                </div>
            </div>
        )
    }
}

const Accordion = props => {
    const { content } = props

    return (
        <div className="accordion" role="tablist">
            {content.map((c, i) => (
                <Collapsible {...{ ...c, key: i }} />
            ))}
        </div>
    )
}

export default Accordion
